export const CART_GET_CART_LIST_REQUEST = 'CART_GET_CART_LIST_REQUEST';
export const CART_GET_CART_LIST_SUCCESS = 'CART_GET_CART_LIST_SUCCESS';
export const CART_GET_CART_LIST_FAILURE = 'CART_GET_CART_LIST_FAILURE';

export const CART_DELETE_CARTS_REQUEST = 'CART_DELETE_CARTS_REQUEST';
export const CART_DELETE_CARTS_SUCCESS = 'CART_DELETE_CARTS_SUCCESS';
export const CART_DELETE_CARTS_FAILURE = 'CART_DELETE_CARTS_FAILURE';
export const CART_APPLY_ORDER_DETAILS = 'CART_APPLY_ORDER_DETAILS';
